import { createFileRoute } from '@tanstack/react-router';
import { PilotPage } from '@/components/OttoPilot/PilotPage';

export const Route = createFileRoute('/_authenticated/pilot/$')({
  component: PilotPage,
});
